import React from "react";
import config from "../../../package.json";

export default class Configuration {
    static appName: string = config.name;
    static appVersion: string = config.versionName;
    static friendlyName: string = config.friendlyName;
    static version: string = config.version;
    static platformVersion: string = React.version;
    static isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    static isWin = navigator.platform.toUpperCase().indexOf("WIN") >= 0;

    static authenticationPath: string = "";
    static servicesPath: string = "";
    static messagingPath: string = "";
    static renderingPath: string = "";
    static socketsPath: string = "";
    static managementPath: string = "";
    static applicationToken: string = "";

    static fileBased: boolean = false;
    static fileBasedSingle: boolean = false;
    static dateBased: boolean = false;

    static customDomainsSuffix: string = "";

    static addressServiceKey: string = "";

    static async initialise() {
        const response = await fetch("./config.json");
        const configData = await response.json();
        Configuration.authenticationPath = configData.authenticationPath;
        Configuration.servicesPath = configData.servicesPath;
        Configuration.messagingPath = configData.messagingPath;
        Configuration.renderingPath = configData.renderingPath;
        Configuration.socketsPath = configData.socketsPath;
        Configuration.managementPath = configData.managementPath;
        Configuration.applicationToken = configData.applicationToken;
        Configuration.fileBased = configData.fileBased;
        Configuration.fileBasedSingle = configData.fileBasedSingle;
        Configuration.dateBased = configData.dateBased;
        Configuration.customDomainsSuffix = configData.customDomainsSuffix;
        Configuration.addressServiceKey = configData.addressServiceKey;
    }
}
